import React from "react";
import { Col, Form, Input, Row } from "antd";
import { ClientSectionSlot as BaseClientSectionSlot } from "../../common/components";

export const ClientSlot = ({ ...baseProps }) => {
    return (
        <>
            <BaseClientSectionSlot {...baseProps} />
            <Row gutter={16}>
                <Col xs={24} sm={12}>
                    <Form.Item
                        name="Student_Grade"
                        label="Grado"
                    >
                        <Input placeholder="Grado del alumno" />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                    <Form.Item
                        name="Student_Name"
                        label="Nombre Alumno"
                    >
                        <Input placeholder="Nombre del alumno" />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col xs={24} sm={12}>
                    <Form.Item
                        name="Student_DNI"
                        label="DNI Alumno"
                        rules={[
                            {
                                pattern: /^\d{8}$/,
                                message: "El DNI del alumno debe tener exactamente 8 dígitos",
                            }
                        ]}
                    >
                        <Input placeholder="DNI del alumno" maxLength={8} />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                    <Form.Item
                        name="Student_Phone"
                        label="Teléfono Alumno"
                    >
                        <Input placeholder="Teléfono del alumno" />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};
